import styled from 'styled-components'

export const BoxBase = styled.div`
  padding: 4px 10px;
  text-align: center;
`
